import { Stack } from 'expo-router';

import { useMqSelect } from '@fhs/ui';

import { getScreenTitleHeader } from '../../../components/get-screen-title-header';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function OffersStackLayout() {
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);
  return (
    <Stack
      screenOptions={{
        header: getScreenTitleHeader({
          cannotGoBackHref: '/menu',
          showDivider: true,
        }),
        headerShown: !isDesktop,
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen
        name="details/[offerId]"
        options={{
          presentation: 'containedTransparentModal',
          headerShown: false,
          animation: 'slide_from_bottom',
        }}
      />
      <Stack.Screen
        name="guide/[offerId]"
        options={{
          presentation: 'containedTransparentModal',
          headerShown: false,
          animation: 'slide_from_bottom',
        }}
      />
      <Stack.Screen
        name="all"
        options={{
          title: 'See All Offers',
        }}
      />
    </Stack>
  );
}
